var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{ref:"distributionChart",attrs:{"autoresize":"","option":_vm.donutOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }